var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"checkbox",on:{"click":_vm.toggleCheckbox}},[_c('div',{class:['checkbox__square', {'checkbox__square_active': _vm.checked}]}),_c('p',{staticClass:"checkbox__label"},[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }